<template>
  <a>
    <span class="modal-body-text">Unable to submit some events due to incomplete information. Please fill in required information and continue submitting.</span><br/><br/>
    <span class="modal-body-text">All completed events have been submitted.</span><br/>
  </a>
</template>

<script>
export default {
  name: 'submit-all-body-modal'
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// SubmitAllEventEmptyFieldsError.vue?789c0d0e